export default "__VITE_ASSET__CbpA34Ht__"